import { Alert, AlertDescription } from '@/components/ui/alert';
import { formatEuros, formatRatio } from '@/lib/format';
import { DealForm } from '@/features/simulations/DealForm';
import { SavedSimulations } from '@/features/simulations/SavedSimulations';
import { SimulateurTabs } from '@/features/simulations/SimulateurTabs';
import { analyzeDeal } from '@app/finance';

export function SimulateurAchatReventePage() {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-2xl font-semibold">Simulateur</h1>
      <SimulateurTabs />
      <Alert>
        <AlertDescription>
          Moteur <code>deal-2026</code>, distinct du moteur locatif : fiscalité d’une société à l’IS,
          sans lien avec la résidence fiscale. Modèle indicatif, à faire valider par votre comptable
          (établissement stable, TVA, taux réduit d’IS). Le crédit n’est modélisé qu’en intérêts sur
          la durée de portage ; la TVA « sur le prix total » (rénovation lourde) n’est pas modélisée.
        </AlertDescription>
      </Alert>
      <DealForm />
      <SavedSimulations
        kind="deal"
        renderHeadline={(simulation) => {
          const { realistic } = analyzeDeal(simulation.input).scenarios;
          return (
            <span>
              Réaliste : {formatEuros(realistic.netMargin)} net ({formatRatio(realistic.netMarginRate)})
            </span>
          );
        }}
      />
    </div>
  );
}
